import { useTranslation } from 'next-i18next'
import { useCallback } from 'react'
import { localeNamespace } from './i18n/Locale'
import { balerSubtypeTranslationMapping } from './i18n/translationMappings'
import { MachineSubType } from './MachineType'

export const useMachineSubTypeName = () => {
  const { t } = useTranslation(localeNamespace.common)

  const getMachineSubTypeName = useCallback(
    (machineSubType: MachineSubType) =>
      t(balerSubtypeTranslationMapping[machineSubType]),
    [t]
  )

  return { getMachineSubTypeName }
}
